import { STATUS } from '@kontentino/kontentino-constants/Posts';
import { PostCommunicationContent } from 'app/modules/posts/modules/post/components/postCommunication/types/postCommunicationContent';

export const getApprovalCommunicationTabForStatus = (
  status: number,
): PostCommunicationContent | null => {
  switch (status) {
    case STATUS.AT_CLIENT:
    case STATUS.APPROVED:
    case STATUS.REJECTED_BY_CLIENT:
      return PostCommunicationContent.CLIENT;
    case STATUS.WAITING_FOR_INTERNAL_APPROVAL:
    case STATUS.INTERNAL_APPROVED:
    case STATUS.REJECTED:
      return PostCommunicationContent.INTERNAL;
    default:
      return null;
  }
};
